import React from 'react';
import CreateCampaignBody from './modal/createCampaingBody';
import AddSitesBody from './modal/addSitesBody';
import CreatePortalBody from './modal/createPortalBody';

const creationSteps = (newCampaign, setNewCampaign) => {
  return [
    {
      title: 'Settings',
      description: 'Creating a new campaign',
      required: true,
      validation: () => {
        const endDateValidation = newCampaign.isOngoingCampaign ? false : newCampaign.endDate === '';
        const endDateBeforeStartDate =
          newCampaign.endDate && new Date(newCampaign.endDate) < new Date(newCampaign.startDate);
        return newCampaign.campaignName && newCampaign.startDate && !endDateValidation && !endDateBeforeStartDate;
      },
      content: <CreateCampaignBody campaignInfo={newCampaign} onChangeCB={setNewCampaign} />
    },
    {
      title: 'Sites',
      description: 'Select sites for your campaign',
      required: false,
      modified: () => {
        return newCampaign.selectedSites && newCampaign.selectedSites.length > 0;
      },
      content: <AddSitesBody campaignInfo={newCampaign} onChangeCB={setNewCampaign} />
    },
    {
      title: 'Brand Portal',
      description: 'Select a brand portal for your campaign',
      required: false,
      validation: () => {
        if (newCampaign.method === 'select') {
          return newCampaign.selectedPortal;
        } else {
          return (
            newCampaign.displayName && newCampaign.displayName.trim() !== '' && newCampaign.displayName.length >= 4
          );
        }
      },
      content: <CreatePortalBody portalInfo={newCampaign} onChangeCB={setNewCampaign} />
    }
  ];
};

export default creationSteps;
